// Service hook (TS-2.5.01, Resource Accessor layer) - GET /api/projects/owners, the same read
// projects/hooks/useOwnerSuggestions.ts and admin/hooks/useOwnerSuggestions.ts wrap, feeding this
// page's "Project lead" filter options. Duplicated here rather than imported across the feature
// boundary, on the codebase's existing precedent (see admin/hooks/useOwnerSuggestions.ts's own
// header) - a failed fetch must not block the data-quality report, so the select simply falls back
// to "All leads" with no other options.
import { useEffect, useState } from "react";
import type { ProjectOwnerSummary } from "../../../api/generated/contracts";
import { portfolioDataApi } from "../../../api/portfolioData";

export interface UseOwnerSuggestionsResult {
  readonly owners: readonly ProjectOwnerSummary[];
}

export function useOwnerSuggestions(): UseOwnerSuggestionsResult {
  const [owners, setOwners] = useState<readonly ProjectOwnerSummary[]>([]);

  useEffect(() => {
    let cancelled = false;

    void portfolioDataApi
      .listOwners()
      .then((next) => {
        if (!cancelled) setOwners(next);
      })
      .catch(() => {
        // Non-fatal: the report still renders, just with only "All leads" to choose from.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { owners };
}
